import { Row, Col, FormGroup } from 'react-bootstrap';
import React, { Component } from 'react';
import FormularioPadrao from '../FormularioPadrao';
import Label from '../../components/Label';
import TextInput from '../../components/TextInput';
import IntegerInput from '../../components/IntegerInput';
import DecimalInput from '../../components/DecimalInput';
import { buildQueryString, updateState } from '../../utils/Functions';
import SubCadastro from '../../components/SubCadastro';
import Select from '../../components/Select';
import TipoDeEnsaioView from './TipoDeEnsaioView';

import SequenciaABIController from '../../controllers/Sequencias/SequenciaABIController';

import {
   getTiposDeOperacaoABI,
   getTiposDeTestesABI,
   getTiposDeUnidadeDesvioABI,
   getTiposDeTiposDeCargasABI,
} from '../Descricoes';
import { showError } from '../../components/Messages';
import { Link } from 'react-router-dom';
import { faSortDown, faSortUp } from '@fortawesome/free-solid-svg-icons';
import Button from '../../components/Button';
import CheckListView from '../Empresa/CheckListView';
import IconButton from '../../components/IconButton';

export default class SequenciaABIView extends Component {
   constructor(props) {
      super(props);
      this.state = {};
      this.controller = new SequenciaABIController(this);
   }

   setUltimoItemCriado = (item) => {
      updateState(this, (state) => {
         state.ultimoItemCriado = {};
         state.ultimoItemCriado.numero = item.numero;
         state.ultimoItemCriado.tipoDeTeste = item.tipoDeTeste;
         state.ultimoItemCriado.modoBisturi = item.modoBisturi;
         state.ultimoItemCriado.tipoCarga = item.tipoCarga;
         state.ultimoItemCriado.carga = item.carga;
         state.ultimoItemCriado.limiteFuga = item.limiteFuga;
         state.ultimoItemCriado.potencia = item.potencia;
         state.ultimoItemCriado.limiteSuperior = item.limiteSuperior;
         state.ultimoItemCriado.limiteInferior = item.limiteInferior;
         state.ultimoItemCriado.unidadeLimites = item.unidadeLimites;
      });
   };

   getDescricaoDoTipoDeTeste = (id) => {
      let result = getTiposDeTestesABI(this.props.lang).filter((i) => i.id === id);
      return result.length > 0 ? result[0].descricao : null;
   };
   getDescricaoDaOperacoesABI = (id) => {
      let result = getTiposDeOperacaoABI(this.props.lang).filter((i) => i.id === id);
      return result.length > 0 ? result[0].descricao : null;
   };
   getDescricaoDaUnidadeDesvioABI = (id) => {
      let result = getTiposDeUnidadeDesvioABI(this.props.lang).filter((i) => i.id === id);
      return result.length > 0 ? result[0].descricao : null;
   };
   getDescricaoDoTipoDeCargaABI = (id) => {
      let result = getTiposDeTiposDeCargasABI(this.props.lang).filter((i) => i.id === id);
      return result.length > 0 ? result[0].descricao : null;
   };

   renderizarFormulario = () => {
      let lang = this.props.lang;
      return (
         <React.Fragment>
            <Row>
               <Col sm={2} md={2} lg={2}>
                  <FormGroup>
                     <Label>{lang.codigo}</Label>
                     <TextInput readOnly defaultValue={this.state.itemSelecionado.id} />
                  </FormGroup>
               </Col>
               <Col>
                  <FormGroup>
                     <Label>{lang.sequencia.nome}</Label>
                     <TextInput
                        defaultValue={this.state.itemSelecionado.nome}
                        onChange={(e) => {
                           updateState(this, (state) => {
                              state.itemSelecionado.nome = e.target.value;
                           });
                        }}
                        upperCase={true}
                     />
                  </FormGroup>
               </Col>
               <Col sm={3} md={3} lg={3}>
                  <FormGroup>
                     <Label>{lang.sequencia.situacao}</Label>
                     <Select
                        name='situacao'
                        defaultValue={this.state.itemSelecionado.situacao && this.state.itemSelecionado.situacao.id}
                        options={[
                           { id: 1, descricao: lang.sequencia.ativa },
                           { id: 2, descricao: lang.sequencia.inativa },
                        ]}
                        getKeyValue={(i) => i.id}
                        getDescription={(i) => i.descricao}
                        onSelect={(i) => {
                           updateState(this, (state) => {
                              state.itemSelecionado.situacao = i;
                           });
                        }}
                     />
                  </FormGroup>
               </Col>
            </Row>

            <br />

            <SubCadastro
               titulo={lang.sequencia.tiposDeEnsaio}
               modal={true}
               exibirTitulos={false}
               itens={this.state.itemSelecionado.tiposDeEnsaio}
               lang={lang}
               novo={() => {
                  return new Promise((resolve) => {
                     updateState(this, (state) => {
                        state.tipoDeEnsaioSelecionado = {
                           tipoDeEnsaio: null,
                        };
                     }).then(() => resolve());
                  });
               }}
               inserir={() => {
                  return new Promise((resolve, reject) => {
                     if (!this.state.tipoDeEnsaioSelecionado.tipoDeEnsaio) {
                        showError(lang.sequencia.mensagens.informeOTipoDeEnsaio);
                        reject();
                        return false;
                     }

                     updateState(this, (state) => {
                        if (!state.itemSelecionado.tiposDeEnsaio) {
                           state.itemSelecionado.tiposDeEnsaio = [];
                        }
                        state.itemSelecionado.tiposDeEnsaio.push({
                           tipoDeEnsaio: this.state.tipoDeEnsaioSelecionado.tipoDeEnsaio,
                        });
                     }).then(() => resolve());
                  });
               }}
               cancelar={() => {
                  return new Promise((resolve) => {
                     updateState(this, (state) => {
                        state.tipoDeEnsaioSelecionado = null;
                     }).then(() => resolve());
                  });
               }}
               excluir={(index) => {
                  updateState(this, (state) => {
                     state.itemSelecionado.tiposDeEnsaio.splice(index, 1);
                  });
               }}
               colunas={() => {
                  return [{ titulo: 'Cargo', width: '100%', className: null }];
               }}
               linha={(item) => {
                  return [item.tipoDeEnsaio.nome];
               }}
               formulario={() => {
                  return (
                     <Row>
                        <Col>
                           <Label>{lang.sequencia.tipoDeEnsaio}</Label>
                           <Select
                              name={'tipoDeEnsaio'}
                              modal={true}
                              defaultValue={this.state.tipoDeEnsaioSelecionado.tipoDeEnsaio}
                              getKeyValue={(i) => i.id}
                              getDescription={(i) => (i && i.nome ? i.nome.toUpperCase() : null)}
                              onSelect={(i) => {
                                 updateState(this, (state) => {
                                    state.tipoDeEnsaioSelecionado.tipoDeEnsaio = i;
                                 });
                              }}
                              formularioPadrao={(select) => {
                                 return (
                                    <TipoDeEnsaioView api={this.props.api} select={select} lang={this.props.lang} />
                                 );
                              }}
                              asws={true}
                              noDropDown={true}
                              readOnlyColor='#ffff'
                              getFilterUrl={(text) =>
                                 '/tipodeensaio' + buildQueryString(2, null, 'id', { Searchable: text })
                              }
                           />
                        </Col>
                     </Row>
                  );
               }}
            />

            <br />

            {!this.state.itemSelecionado.sequenciaNeos && (
               <SubCadastro
                  titulo={lang.sequencia.checkList}
                  modal={true}
                  exibirTitulos={false}
                  itens={this.state.itemSelecionado.checkList}
                  lang={lang}
                  novo={() => {
                     return new Promise((resolve) => {
                        updateState(this, (state) => {
                           state.checkListSelecionado = {
                              checkList: null,
                           };
                        }).then(() => resolve());
                     });
                  }}
                  inserir={() => {
                     return new Promise((resolve, reject) => {
                        if (!this.state.checkListSelecionado.checkList) {
                           showError(lang.sequencia.mensagens.informeOCheckList);
                           reject();
                           return false;
                        }

                        updateState(this, (state) => {
                           if (!state.itemSelecionado.checkList) {
                              state.itemSelecionado.checkList = [];
                           }
                           state.itemSelecionado.checkList.push({
                              checkList: this.state.checkListSelecionado.checkList,
                           });
                        }).then(() => resolve());
                     });
                  }}
                  cancelar={() => {
                     return new Promise((resolve) => {
                        updateState(this, (state) => {
                           state.checkListSelecionado = null;
                        }).then(() => resolve());
                     });
                  }}
                  excluir={(index) => {
                     updateState(this, (state) => {
                        state.itemSelecionado.checkList.splice(index, 1);
                     });
                  }}
                  colunas={() => {
                     return [{ titulo: lang.sequencia.checkList, width: '100%', className: null }];
                  }}
                  linha={(item) => {
                     return [item.checkList.descricao];
                  }}
                  formulario={() => {
                     return (
                        <Row>
                           <Col>
                              <Label>{lang.sequencia.checkList}</Label>
                              <Select
                                 name={'checkList'}
                                 modal={true}
                                 defaultValue={this.state.checkListSelecionado.checkList}
                                 getKeyValue={(i) => i.id}
                                 getDescription={(i) => i.descricao}
                                 onSelect={(i) => {
                                    updateState(this, (state) => {
                                       state.checkListSelecionado.checkList = i;
                                    });
                                 }}
                                 formularioPadrao={(select) => {
                                    return (
                                       <CheckListView api={this.props.api} select={select} lang={this.props.lang} />
                                    );
                                 }}
                                 noDropDown={true}
                                 readOnlyColor='#ffff'
                                 getFilterUrl={(text) =>
                                    '/checklist' + buildQueryString(2, null, 'descricao', { Searchable: text })
                                 }
                              />
                           </Col>
                        </Row>
                     );
                  }}
               />
            )}

            <br />

            <SubCadastro
               titulo='Testes'
               exibirTitulos={true}
               itens={this.state.itemSelecionado.itens}
               lang={lang}
               tituloDoBotaoCancelar={lang.sequencia.finalizarCadastroDeTeste}
               gradeSempreVisivel={true}
               novo={
                  !this.state.itemSelecionado.sequenciaNeos ||
                  (this.state.itemSelecionado.sequenciaNeos && this.props.sessionManager.isUsuarioNeos())
                     ? () => {
                          return new Promise((resolve) => {
                             let maiorNumero = 0;
                             if (this.state.itemSelecionado.itens) {
                                this.state.itemSelecionado.itens.map((i, index) => {
                                   if (i.numero > maiorNumero) {
                                      maiorNumero = i.numero;
                                   }
                                   return true;
                                });
                             }
                             maiorNumero++;
                             updateState(this, (state) => {
                                state.configuracaoSelecionada = null;
                                let configuracaoSelecionada = { tipoDeTeste: 0 };
                                this.setValoresDefault(configuracaoSelecionada);
                                configuracaoSelecionada.numero = maiorNumero;
                                state.configuracaoSelecionada = configuracaoSelecionada;
                             }).then(() => resolve());
                          });
                       }
                     : null
               }
               inserir={() => {
                  return new Promise((resolve, reject) => {
                     if (this.state.configuracaoSelecionada.tipoDeTeste === 0x00) {
                        if (!this.state.configuracaoSelecionada.numero) {
                           showError(lang.informeONumero);
                           reject();
                           return false;
                        }

                        if (!this.state.configuracaoSelecionada.carga) {
                           showError(lang.cadastroDeSequenciaABI.mensagens.informeACarga);
                           reject();
                           return false;
                        }

                        if (!this.state.configuracaoSelecionada.limiteSuperior) {
                           showError(lang.cadastroDeSequenciaABI.mensagens.informeOLimiteSuperior);
                           reject();
                           return false;
                        }

                        if (!this.state.configuracaoSelecionada.limiteInferior) {
                           showError(lang.cadastroDeSequenciaABI.mensagens.informeOLimiteInferior);
                           reject();
                           return false;
                        }

                        if (!this.state.configuracaoSelecionada.limiteSuperior) {
                           showError(lang.cadastroDeSequenciaABI.mensagens.informeOLimiteSuperior);
                           reject();
                           return false;
                        }
                        if (!this.state.configuracaoSelecionada.potencia) {
                           showError(lang.cadastroDeSequenciaABI.mensagens.informeAPotencia);
                           reject();
                           return false;
                        }
                     }

                     updateState(this, (state) => {
                        if (this.state.configuracaoSelecionada.tipoDeTeste === 0x00) {
                           if (!this.state.configuracaoSelecionada.numero) {
                              showError(lang.sequencia.informeONumero);
                              reject();
                              return false;
                           }

                           // if (!this.state.configuracaoSelecionada.repeticoes) {
                           //    showError(lang.sequencia.informeONumeroDeRepeticoes);
                           //    reject();
                           //    return false;
                           // }

                           if (!this.state.configuracaoSelecionada.carga) {
                              showError(lang.cadastroDeSequenciaABI.mensagens.informeACarga);
                              reject();
                              return false;
                           }

                           if (!this.state.configuracaoSelecionada.limiteSuperior) {
                              showError(lang.cadastroDeSequenciaABI.mensagens.informeOLimiteSuperior);
                              reject();
                              return false;
                           }

                           if (!this.state.configuracaoSelecionada.limiteInferior) {
                              showError(lang.cadastroDeSequenciaABI.mensagens.informeOLimiteInferior);
                              reject();
                              return false;
                           }

                           if (!this.state.configuracaoSelecionada.limiteSuperior) {
                              showError(lang.cadastroDeSequenciaABI.mensagens.informeOLimiteSuperior);
                              reject();
                              return false;
                           }
                           if (!this.state.configuracaoSelecionada.potencia) {
                              showError(lang.cadastroDeSequenciaABI.mensagens.informeAPotencia);
                              reject();
                              return false;
                           }
                        }

                        if (!state.itemSelecionado.itens) {
                           state.itemSelecionado.itens = [];
                        }

                        if (this.state.configuracaoSelecionada.tipoDeTeste === 0x00) {
                           let item = {
                              numero: this.state.configuracaoSelecionada.numero,
                              repeticoes: 1,
                              tipoDeTeste: this.state.configuracaoSelecionada.tipoDeTeste,
                              modoBisturi: this.state.configuracaoSelecionada.modoBisturi,
                              tipoCarga: this.state.configuracaoSelecionada.tipoCarga,
                              carga: this.state.configuracaoSelecionada.carga,
                              limiteFuga: 0,
                              potencia: this.state.configuracaoSelecionada.potencia,
                              limiteSuperior: this.state.configuracaoSelecionada.limiteSuperior,
                              limiteInferior: this.state.configuracaoSelecionada.limiteInferior,
                              unidadeLimites: this.state.configuracaoSelecionada.unidadeLimites,
                           };

                           state.itemSelecionado.itens.push(item);
                           this.setUltimoItemCriado(item);
                        } else {
                           let item = {
                              numero: this.state.configuracaoSelecionada.numero,
                              repeticoes: 1,
                              tipoDeTeste: this.state.configuracaoSelecionada.tipoDeTeste,
                              modoBisturi: this.state.configuracaoSelecionada.modoBisturi,
                              tipoCarga: this.state.configuracaoSelecionada.tipoCarga,
                              carga: this.state.configuracaoSelecionada.carga,
                              limiteFuga: this.state.configuracaoSelecionada.limiteFuga,
                              potencia: 0,
                              limiteSuperior: 0,
                              limiteInferior: 0,
                              unidadeLimites: 0,
                           };

                           state.itemSelecionado.itens.push(item);
                           this.setUltimoItemCriado(item);
                        }
                     }).then(() => resolve());
                  });
               }}
               aposSalvar={this.aposSalvar}
               selecionarParaAlteracao={(index) => {
                  return new Promise((resolve) => {
                     updateState(this, (state) => {
                        state.configuracaoSelecionada = JSON.parse(JSON.stringify(state.itemSelecionado.itens[index]));
                     }).then(() => resolve());
                  });
               }}
               alterar={(index) => {
                  return new Promise((resolve, reject) => {
                     if (this.state.configuracaoSelecionada.tipoDeTeste === 0x00) {
                        if (!this.state.configuracaoSelecionada.numero) {
                           showError(lang.sequencia.informeONumero);
                           reject();
                           return false;
                        }

                        // if (!this.state.configuracaoSelecionada.repeticoes) {
                        //    showError(lang.sequencia.informeONumeroDeRepeticoes);
                        //    reject();
                        //    return false;
                        // }

                        if (!this.state.configuracaoSelecionada.carga) {
                           showError(lang.cadastroDeSequenciaABI.mensagens.informeACarga);
                           reject();
                           return false;
                        }

                        if (!this.state.configuracaoSelecionada.limiteSuperior) {
                           showError(lang.cadastroDeSequenciaABI.mensagens.informeOLimiteSuperior);
                           reject();
                           return false;
                        }

                        if (!this.state.configuracaoSelecionada.limiteInferior) {
                           showError(lang.cadastroDeSequenciaABI.mensagens.informeOLimiteInferior);
                           reject();
                           return false;
                        }

                        if (!this.state.configuracaoSelecionada.limiteSuperior) {
                           showError(lang.cadastroDeSequenciaABI.mensagens.informeOLimiteSuperior);
                           reject();
                           return false;
                        }
                        if (!this.state.configuracaoSelecionada.potencia) {
                           showError(lang.cadastroDeSequenciaABI.mensagens.informeAPotencia);
                           reject();
                           return false;
                        }
                     }

                     updateState(this, (state) => {
                        state.itemSelecionado.itens[index].numero = this.state.configuracaoSelecionada.numero;
                        state.itemSelecionado.itens[index].repeticoes = this.state.configuracaoSelecionada.repeticoes;
                        state.itemSelecionado.itens[index].tipoDeTeste = this.state.configuracaoSelecionada.tipoDeTeste;
                        state.itemSelecionado.itens[index].modoBisturi = this.state.configuracaoSelecionada.modoBisturi;
                        state.itemSelecionado.itens[index].tipoCarga = this.state.configuracaoSelecionada.tipoCarga;
                        state.itemSelecionado.itens[index].carga = this.state.configuracaoSelecionada.carga;
                        state.itemSelecionado.itens[index].limiteFuga = this.state.configuracaoSelecionada.limiteFuga;
                        state.itemSelecionado.itens[index].potencia = this.state.configuracaoSelecionada.potencia;
                        state.itemSelecionado.itens[index].limiteSuperior =
                           this.state.configuracaoSelecionada.limiteSuperior;
                        state.itemSelecionado.itens[index].limiteInferior =
                           this.state.configuracaoSelecionada.limiteInferior;
                        state.itemSelecionado.itens[index].unidadeLimites =
                           this.state.configuracaoSelecionada.unidadeLimites;
                        this.setUltimoItemCriado(this.state.itemSelecionado.itens[index]);
                     }).then(() => resolve());
                  });
               }}
               cancelar={() => {
                  return new Promise((resolve) => {
                     updateState(this, (state) => {
                        state.configuracaoSelecionada = null;
                     }).then(() => resolve());
                  });
               }}
               excluir={
                  !this.state.itemSelecionado.sequenciaNeos ||
                  (this.state.itemSelecionado.sequenciaNeos && this.props.sessionManager.isUsuarioNeos())
                     ? (index) => {
                          updateState(this, (state) => {
                             state.itemSelecionado.itens.splice(index, 1);
                             state.itemSelecionado.itens.map((i, index) => (i.numero = index + 1));
                          });
                       }
                     : null
               }
               colunas={() => {
                  return [
                     { titulo: 'Nº', width: '3%', className: null },
                     { titulo: 'Tipo de Teste', width: '13%', className: null },
                     { titulo: 'Modo Bisturi', width: '13%', className: null },
                     { titulo: 'Corrente', width: '10%', className: null },
                     { titulo: 'Potência', width: '10%', className: null },
                     { titulo: 'Tipo Carga', width: '10%', className: null },
                     { titulo: 'Carga', width: '5%', className: null },
                     { titulo: 'Desvio máximo superior', width: '13%', className: null },
                     { titulo: 'Desvio máximo inferior', width: '13%', className: null },
                     { titulo: 'Unid desvio', width: '10%', className: null },
                  ];
               }}
               linha={(item) => {
                  if (item.tipoDeTeste === 0x00) {
                     return [
                        item.numero,
                        this.getDescricaoDoTipoDeTeste(item.tipoDeTeste),
                        this.getDescricaoDaOperacoesABI(item.modoBisturi),
                        0,
                        item.potencia,
                        this.getDescricaoDoTipoDeCargaABI(item.tipoCarga),
                        item.carga,
                        item.limiteSuperior,
                        item.limiteInferior,
                        item.unidadeLimites
                           ? this.getDescricaoDaUnidadeDesvioABI(item.unidadeLimites).substring(0, 1)
                           : null,
                     ];
                  } else {
                     return [
                        item.numero,
                        this.getDescricaoDoTipoDeTeste(item.tipoDeTeste),
                        this.getDescricaoDaOperacoesABI(item.modoBisturi),
                        item.limiteFuga,
                        0,
                        this.getDescricaoDoTipoDeCargaABI(item.tipoCarga),
                        item.carga,
                        0,
                        0,
                        this.getDescricaoDaUnidadeDesvioABI(item.unidadeLimites),
                     ];
                  }
               }}
               acoes={(subCadastro, index) => {
                  return (
                     <div style={{ display: 'table-cell', margin: 'auto', marginRight: 4, width: 25 }}>
                        <IconButton
                           title={lang.formularioPadrao.alterar}
                           style={{ fontSize: 23, marginBottom: -10 }}
                           cursor='pointer'
                           icon={faSortUp}
                           onClick={() => {
                              if (this.state.itemSelecionado.itens[index].numero > 1) {
                                 updateState(this, (state) => {
                                    state.itemSelecionado.itens[index - 1].numero =
                                       state.itemSelecionado.itens[index].numero;
                                    state.itemSelecionado.itens[index].numero =
                                       state.itemSelecionado.itens[index].numero - 1;
                                 }).then(() => {
                                    this.setUltimoItemCriado(this.state.itemSelecionado.itens[index]);
                                    this.aposSalvar(subCadastro, false, true);
                                 });
                              }
                           }}
                        />
                        <IconButton
                           title={lang.formularioPadrao.alterar}
                           style={{ fontSize: 23, marginTop: -10 }}
                           cursor='pointer'
                           icon={faSortDown}
                           onClick={() => {
                              if (
                                 this.state.itemSelecionado.itens[index].numero <
                                 this.state.itemSelecionado.itens.length
                              ) {
                                 updateState(this, (state) => {
                                    state.itemSelecionado.itens[index + 1].numero =
                                       state.itemSelecionado.itens[index].numero;
                                    state.itemSelecionado.itens[index].numero =
                                       state.itemSelecionado.itens[index].numero + 1;
                                 }).then(() => {
                                    this.setUltimoItemCriado(this.state.itemSelecionado.itens[index]);
                                    this.aposSalvar(subCadastro, false, true);
                                 });
                              }
                           }}
                        />
                     </div>
                  );
               }}
               formulario={() => {
                  return this.state.configuracaoSelecionada ? (
                     <div>
                        <Row>
                           <Col sm={2} md={2} lg={2}>
                              <FormGroup>
                                 <Label>{lang.sequencia.numero}</Label>
                                 <IntegerInput
                                    defaultValue={this.state.configuracaoSelecionada.numero}
                                    onChange={(e) => {
                                       updateState(this, (state) => {
                                          state.configuracaoSelecionada.numero = e.floatValue;
                                       });
                                    }}
                                 />
                              </FormGroup>
                           </Col>

                           {/* <Col xs={2} md={2} xl={2}>
                              <FormGroup>
                                 <Label>{lang.sequencia.repeticoes}</Label>
                                 <IntegerInput
                                    // defaultValue={this.state.configuracaoSelecionada.repeticoes}
                                    defaultValue={1}
                                    onChange={(e) => {
                                       updateState(this, (state) => {
                                          state.configuracaoSelecionada.repeticoes = e.floatValue;
                                       });
                                    }}
                                    readOnly={true}
                                 />
                              </FormGroup>
                           </Col> */}

                           <Col>
                              <FormGroup>
                                 <Label>{lang.cadastroDeSequenciaABI.tipoDeTeste}</Label>
                                 <Select
                                    defaultValue={this.state.configuracaoSelecionada.tipoDeTeste}
                                    options={getTiposDeTestesABI(lang)}
                                    getKeyValue={(i) => i.id}
                                    getDescription={(i) => i.descricao}
                                    allowEmpty={false}
                                    onSelect={(i) => {
                                       updateState(this, (state) => {
                                          if (i != null) {
                                             state.configuracaoSelecionada.tipoDeTeste = i.id;
                                          } else {
                                             state.configuracaoSelecionada.tipoDeTeste = 0;
                                          }
                                          let configuracaoSelecionada = state.configuracaoSelecionada;
                                          this.setValoresDefault(configuracaoSelecionada);
                                          state.configuracaoSelecionada = configuracaoSelecionada;
                                       });
                                    }}
                                 />
                              </FormGroup>
                           </Col>
                           <Col>
                              <FormGroup>
                                 <Label>{lang.cadastroDeSequenciaABI.modoBisturi}</Label>
                                 <Select
                                    defaultValue={this.state.configuracaoSelecionada.modoBisturi}
                                    options={getTiposDeOperacaoABI(lang)}
                                    getKeyValue={(i) => i.id}
                                    getDescription={(i) => i.descricao}
                                    allowEmpty={false}
                                    onSelect={(i) => {
                                       updateState(this, (state) => {
                                          if (i != null) {
                                             state.configuracaoSelecionada.modoBisturi = i.id;
                                          } else {
                                             state.configuracaoSelecionada.modoBisturi = 0;
                                          }
                                       });
                                    }}
                                 />
                              </FormGroup>
                           </Col>
                        </Row>

                        <Row>
                           <Col xs={6} md={6} xl={6}>
                              <FormGroup>
                                 <Label>{lang.cadastroDeSequenciaABI.tipoCarga}</Label>
                                 <Select
                                    defaultValue={this.state.configuracaoSelecionada.tipoCarga}
                                    options={getTiposDeTiposDeCargasABI(lang)}
                                    getKeyValue={(i) => i.id}
                                    getDescription={(i) => i.descricao}
                                    allowEmpty={false}
                                    acceptZero={true}
                                    onSelect={(i) => {
                                       updateState(this, (state) => {
                                          if (i != null) {
                                             state.configuracaoSelecionada.tipoCarga = i.id;
                                          } else {
                                             state.configuracaoSelecionada.tipoCarga = 0;
                                          }
                                       });
                                    }}
                                 />
                              </FormGroup>
                           </Col>
                           <Col>
                              <FormGroup>
                                 <Label>{lang.cadastroDeSequenciaABI.carga}</Label>
                                 <DecimalInput
                                    lang={lang}
                                    defaultValue={this.state.configuracaoSelecionada.carga}
                                    onChange={(e) => {
                                       updateState(this, (state) => {
                                          state.configuracaoSelecionada.carga = e.value;
                                       });
                                    }}
                                 />
                              </FormGroup>
                           </Col>
                        </Row>

                        {this.state.configuracaoSelecionada.tipoDeTeste === 0 && (
                           <Row>
                              <Col xs={3} md={3} xl={3}>
                                 <FormGroup>
                                    <Label>{lang.cadastroDeSequenciaABI.potencia}</Label>
                                    <IntegerInput
                                       defaultValue={this.state.configuracaoSelecionada.potencia}
                                       onChange={(e) => {
                                          updateState(this, (state) => {
                                             state.configuracaoSelecionada.potencia = e.floatValue;
                                          });
                                       }}
                                    />
                                 </FormGroup>
                              </Col>
                              <Col xs={3} md={3} xl={3}>
                                 <FormGroup>
                                    <Label>{lang.cadastroDeSequenciaABI.desvioMaximoSuperior}</Label>
                                    <IntegerInput
                                       defaultValue={this.state.configuracaoSelecionada.limiteSuperior}
                                       onChange={(e) => {
                                          updateState(this, (state) => {
                                             state.configuracaoSelecionada.limiteSuperior = e.floatValue;
                                          });
                                       }}
                                    />
                                 </FormGroup>
                              </Col>
                              <Col xs={3} md={3} xl={3}>
                                 <FormGroup>
                                    <Label>{lang.cadastroDeSequenciaABI.desvioMaximoInferior}</Label>
                                    <IntegerInput
                                       defaultValue={this.state.configuracaoSelecionada.limiteInferior}
                                       onChange={(e) => {
                                          updateState(this, (state) => {
                                             state.configuracaoSelecionada.limiteInferior = e.floatValue;
                                          });
                                       }}
                                    />
                                 </FormGroup>
                              </Col>
                              <Col xs={3} md={3} xl={3}>
                                 <FormGroup>
                                    <Label>{lang.cadastroDeSequenciaABI.unidadeDesvio}</Label>

                                    <Select
                                       as='select'
                                       name='unidadeLimites'
                                       defaultValue={this.state.configuracaoSelecionada.unidadeLimites}
                                       options={getTiposDeUnidadeDesvioABI(lang)}
                                       getKeyValue={(i) => i.id}
                                       getDescription={(i) => i.descricao}
                                       allowEmpty={false}
                                       onSelect={(i) => {
                                          updateState(this, (state) => {
                                             if (i != null) {
                                                state.configuracaoSelecionada.unidadeLimites = i.id;
                                             } else {
                                                state.configuracaoSelecionada.unidadeLimites = 0;
                                             }
                                          });
                                       }}
                                    />
                                 </FormGroup>
                              </Col>
                           </Row>
                        )}

                        {this.state.configuracaoSelecionada.tipoDeTeste > 0x00 && (
                           <Row>
                              <Col xs={6} md={6} xl={6}>
                                 <FormGroup>
                                    <Label>{lang.cadastroDeSequenciaABI.correnteDeFugaDeLimite}</Label>
                                    <IntegerInput
                                       defaultValue={this.state.configuracaoSelecionada.limiteFuga}
                                       onChange={(e) => {
                                          updateState(this, (state) => {
                                             state.configuracaoSelecionada.limiteFuga = e.floatValue;
                                          });
                                       }}
                                    />
                                 </FormGroup>
                              </Col>
                           </Row>
                        )}
                     </div>
                  ) : (
                     <div />
                  );
               }}
            />
            <br />
         </React.Fragment>
      );
   };

   renderizarAcoesDoFormulario = () => {
      return (
         <div>
            <Button
               text={this.props.lang.sequencia.duplicarSequencia}
               style={{ width: 200 }}
               onClick={() => {
                  let item = JSON.parse(JSON.stringify(this.state.itemSelecionado));
                  item.id = null;
                  if (item.itens != null) {
                     for (let i = 0; i < item.itens.length; i++) {
                        item.itens[i].id = null;
                     }
                  }
                  if (item.tiposDeEnsaio != null) {
                     for (let i = 0; i < item.tiposDeEnsaio.length; i++) {
                        item.tiposDeEnsaio[i].id = null;
                     }
                  }

                  updateState(this, (state) => {
                     state.incluindo = false;
                     state.alterando = false;
                     state.valorPadrao = item;
                  }).then(() => {
                     this.form.inserirClick();
                  });
               }}
            />
            <br />
         </div>
      );
   };

   aposSalvar = (subCadastro, inserindo, alterando) => {
      let ordem = this.state.ultimoItemCriado.numero;
      updateState(this, (state) => {
         state.itemSelecionado.itens.sort((i, j) => {
            let result = i.numero < j.numero ? -1 : i.numero > j.numero ? 1 : 0;
            if (j.numero === ordem && i.numero === ordem) {
               result = -1;
            }
            return result;
         });
         state.itemSelecionado.itens.map((i, index) => (i.numero = index + 1));
      });
      if (inserindo) {
         subCadastro.novo();
      }
   };

   setValoresDefault = (item) => {
      let padrao = null;

      if (this.state.ultimoItemCriado && !this.state.configuracaoSelecionada) {
         padrao = this.state.ultimoItemCriado;
      } else if (item !== null) {
         padrao = {
            tipoDeTeste: item.tipoDeTeste,
         };
      } else {
         padrao = {
            tipoDeTeste: 0,
         };
      }

      if (padrao) {
         item.repeticoes = 1;
         item.tipoDeTeste = padrao.tipoDeTeste;
      }
   };

   render() {
      return (
         <FormularioPadrao
            titulo={
               <div>
                  <Link
                     to={'/sequencia'}
                     replace={true}
                     style={{
                        textDecoration: 'none',
                        padding: '5px 5px 5px 0px',
                        cursor: 'pointer',
                     }}
                  >
                     <span style={{ opacity: 0.7 }}>{this.props.lang.sequencias}</span>                    
                  </Link>
                  <span>{' - '}</span>                  
                  <span>{this.props.lang.cadastroDeSequenciaABI.titulo}</span>
               </div>
            }
            url={'/sequenciaabi'}
            fastUrl={'/sequenciaabi/fast'}
            api={this.props.api}
            lang={this.props.lang}
            ordenacaoPadrao={'id'}
            permissoes={[1181, 1182, 1183, 1184]}
            getFiltro={this.controller.getFiltro}
            getTitulosDaTabela={this.controller.getTitulosDaTabela}
            getDadosDaTabela={this.controller.getDadosDaTabela}
            renderizarFormulario={this.renderizarFormulario}
            renderizarAcoesDoFormulario={this.renderizarAcoesDoFormulario}
            getObjetoDeDados={this.controller.getObjetoDeDados}
            antesDeInserir={this.controller.antesDeInserir}
            antesDeEditar={this.controller.antesDeEditar}
            antesDeSalvar={this.controller.antesDeSalvar}
            antesDeExcluir={this.controller.antesDeExcluir}
            getFormState={() => {
               return this.state;
            }}
            ref={(c) => (this.form = c)}
            definirValoresPadrao={(item) => {
               return this.state.valorPadrao ? this.state.valorPadrao : item;
            }}
            setFormState={(state, callback) => {
               return new Promise((resolve) => {
                  this.setState(state, () => {
                     resolve();
                     if (callback) {
                        callback();
                     }
                  });
               });
            }}
            select={this.props.select}
            itemVazio={{
               acessos: [],
               tipoDeTeste: { id: 1 },
            }}
         />
      );
   }
}
